'use strict';
var React = require('react');
var Components = require('./Components.jsx');
var appTypes = require('../../types/appTypes.js');

var Popup = React.createClass({
  propTypes: {
    components: React.PropTypes.array.isRequired,
    height: React.PropTypes.string.isRequired,
    events: React.PropTypes.object.isRequired,
    onLinkClick: React.PropTypes.func.isRequired,
    onLoad: React.PropTypes.func.isRequired,
    pageScrollTop: React.PropTypes.number.isRequired
  },

  offsetY: function(comps, scrollTop) {
    if(!comps || !scrollTop) {
      return;
    }
    var cloneComps = JSON.parse(JSON.stringify(comps));
    return cloneComps.map((comp) => {
      return Object.assign(comp, {}, {
        y: comp.y - scrollTop,
        items: this.offsetY(comp.items, scrollTop)
      })
    })
  },

  // getInitialState: function() {
  //   //处理拉长页面下，弹出面板的显示位置
  //   var scrollTop = this.props.pageScrollTop;
  //   var comps = this.offsetY(this.props.components, scrollTop);
  //   return {
  //     comps: comps || this.props.components
  //   }
  // },

  render: function () {
    return (
      <div key="popup-page" className='page-popup' style={{
        height: 0,
        zIndex : 20,
        position : 'absolute',
        left : 0,
        top : 0,
        width : 0,
      }}>
        <Components
          components={this.props.components}
          events={this.props.events}
          onLoad={this.props.onLoad}
        />
      </div>
    );
  },

  isCanEvents : function(){
    var r = false;
    var i = 0;
    var item;
    for(i;i < this.props.components.length;i++){
      item = this.props.components[i];
      if(item.closeByClickMode !== appTypes.PopupPanelClosePolicy.NONE){
        r = true;
        break;
      }
    }
    return r;
  }
});

module.exports = Popup;


// WEBPACK FOOTER //
// ./src/views/Page/Popup.jsx